import { ImageComponent, SpanTag, Spinner } from "@tm/static";
import { usePartnerContext } from "@tm/static/partnerContext";
import { theme } from "@tm/utility/global";
import React from "react";
import { BtnProp } from "./ButtonType";
import { LandingButtonStyle, ShimmerWrap } from "./LandingButton.style";

const LandingButton = ({
  customTitle,
  margin,
  customWidth,
  disableState,
  onClick,
  flexShrink,
  shimmerBtn,
  flex,
  customHeight,
  btnLeftIcon,
  btnRightIcon,
  contentAlign,
  fontSize,
  isLoading,
  buttonref,
  letterSpacing,
}: BtnProp) => {
  const context = usePartnerContext();

  return (
    <LandingButtonStyle
      ref={buttonref}
      onClick={onClick}
      customWidth={customWidth}
      margin={margin}
      customHeight={customHeight}
      flexShrink={flexShrink}
      flex={flex}
      fontSize={fontSize}
      letterSpacing={letterSpacing}
      disableState={disableState}
      btnTheme={context ? context : undefined}
      txtClipIcon={btnLeftIcon !== "" && btnRightIcon !== ""}
      contentAlign={contentAlign}
    >
      {isLoading ? (
        <Spinner spinnerColor={"#fff"} />
      ) : contentAlign === "left" && btnLeftIcon ? (
        <>
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              paddingRight: "12px",
              minWidth: 0,
            }}
          >
            <ImageComponent
              width="24px"
              height="24px"
              src={btnLeftIcon}
              margin="0"
            />
          </div>
          {customTitle ? (
            <SpanTag
              color={theme.blueText}
              fontSize="md"
              fontWeight="black"
              style={{ flexShrink: 0 }}
            >
              {customTitle}
            </SpanTag>
          ) : null}
          <div style={{ flex: 1, minWidth: 0 }} />
        </>
      ) : (
        <React.Fragment>
          {btnLeftIcon && (
            <ImageComponent
              width="24px"
              height="24px"
              src={btnLeftIcon}
              margin="0 12px 0 0"
            />
          )}
          {customTitle && (
            <SpanTag color={theme.blueText} fontSize="md" fontWeight="black">
              {customTitle}
            </SpanTag>
          )}
          {shimmerBtn && (
            <ShimmerWrap>
              <img src="../../../images/shimmerBtn.svg" />
            </ShimmerWrap>
          )}
          {btnRightIcon && (
            <ImageComponent
              width="16px"
              height="16px"
              margin="0 0 0 auto"
              src={btnRightIcon}
            />
          )}
        </React.Fragment>
      )}
    </LandingButtonStyle>
  );
};

export default LandingButton;
